import { useMutation } from "@apollo/client/react";
import { CREATE_TEMPLATE_WITH_FILE_CONTENT } from "../../mutations/invoiceInterpretationTemplates/createTemplateWithFileContent";
import GET_CLIENT_TEMPLATES from "../../queries/documentHandler/getClientTemplates";

export const useCreateTemplateWithFileContent = ({
  onCompleted,
  onError,
  clientIdentifier,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
  clientIdentifier: string;
}) => {
  const [createTemplateWithFileContent, { data, loading, error }] =
    useMutation(CREATE_TEMPLATE_WITH_FILE_CONTENT, {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [
        {
          query: GET_CLIENT_TEMPLATES,
          variables: { clientIdentifier },
        },
      ],
    });

  return { createTemplateWithFileContent, data, loading, error };
};